
































































import { Vue, Component } from 'vue-property-decorator'

export default Vue.extend({
  data() {
    return {
      events: <any>[],
      newEvent: {
        name: "",
        url: ""
      }
    }
  },
  created(): void {
    this.$store.dispatch("API_CALL", { method: "get", url: "/events", headers: {
      "x-access-token": localStorage.adminToken
    }}).then((res) => {
      this.events = res.data;
    })
  },

  methods: {
    createNewEvent() {
      const newEvent = this.newEvent;
      if(!newEvent.name || !newEvent.url) return;

      this.$store.dispatch("API_CALL", { method: "post", url: "/events", headers: {
        "x-access-token": localStorage.adminToken
      }, data: this.newEvent }).then((res) => {
        this.events.push(res.data);
        newEvent.name = "";
        newEvent.url = "";
        // @ts-ignore 
        this.$refs['createModal'].hide();
      }).catch((err) => {
        console.log(err);
      })
    }
  }
})
